var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-docs (1) 1",
    clipPath: "url(#clip0_43_11617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6034 4.00381L9.9483 0.348715C9.86298 0.263366 9.74653 0.214844 9.62518 0.214844H3.2286C2.4728 0.214844 1.85791 0.829737 1.85791 1.58554V14.4396C1.85791 15.1954 2.4728 15.8103 3.2286 15.8103H12.3666C13.1224 15.8103 13.7373 15.1954 13.7373 14.4396V4.32693C13.7373 4.20235 13.685 4.08535 13.6034 4.00381ZM10.0821 1.77479L12.1773 3.87003H10.539C10.287 3.87003 10.0821 3.66506 10.0821 3.41313V1.77479ZM12.3666 14.8965H3.2286C2.97667 14.8965 2.77171 14.6915 2.77171 14.4396V1.58554C2.77171 1.3336 2.97667 1.12864 3.2286 1.12864H9.16828V3.41313C9.16828 4.16893 9.78318 4.78383 10.539 4.78383H12.8235V14.4396C12.8235 14.6915 12.6185 14.8965 12.3666 14.8965Z",
    fill: "#0F83A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5388 6.67236H5.05602C4.80369 6.67236 4.59912 6.87693 4.59912 7.12926C4.59912 7.38159 4.80369 7.58616 5.05602 7.58616H10.5388C10.7911 7.58616 10.9957 7.38159 10.9957 7.12926C10.9957 6.87693 10.7911 6.67236 10.5388 6.67236Z",
    fill: "#0F83A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5388 8.49988H5.05602C4.80369 8.49988 4.59912 8.70445 4.59912 8.95678C4.59912 9.20911 4.80369 9.41367 5.05602 9.41367H10.5388C10.7911 9.41367 10.9957 9.20911 10.9957 8.95678C10.9957 8.70445 10.7911 8.49988 10.5388 8.49988Z",
    fill: "#0F83A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.5388 10.3275H5.05602C4.80369 10.3275 4.59912 10.5321 4.59912 10.7844C4.59912 11.0367 4.80369 11.2413 5.05602 11.2413H10.5388C10.7911 11.2413 10.9957 11.0367 10.9957 10.7844C10.9957 10.5321 10.7911 10.3275 10.5388 10.3275Z",
    fill: "#0F83A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.71121 12.1552H5.05602C4.80369 12.1552 4.59912 12.3597 4.59912 12.612C4.59912 12.8644 4.80369 13.0689 5.05602 13.0689H8.71121C8.96353 13.0689 9.1681 12.8644 9.1681 12.612C9.1681 12.3597 8.96353 12.1552 8.71121 12.1552Z",
    fill: "#0F83A0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_11617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5955,
    height: 15.5955,
    fill: "white",
    transform: "translate(0 0.214844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocUploadIcon);
export default __webpack_public_path__ + "static/media/doc-upload-icon.3f3d61f758cc39c08bac0f4e9dc069f5.svg";
export { ForwardRef as ReactComponent };